export function timeRemain(date: string) {
  let defaultTimeBeforeExpire = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
  let createdUTC = new Date(date).getTime();
  let nowUTC = new Date().getTime();

  let remainingMilliseconds = createdUTC + defaultTimeBeforeExpire - nowUTC;

  if (remainingMilliseconds <= 0) {
    return { hours: 0, minutes: 0, seconds: 0 };
  }

  let hours = Math.floor((remainingMilliseconds / (1000 * 60 * 60)) % 24);
  let minutes = Math.floor((remainingMilliseconds / (1000 * 60)) % 60);
  let seconds = Math.floor((remainingMilliseconds / 1000) % 60);

  return { hours, minutes, seconds };
}
